import { ArrayDataSource } from './BaseDataSources';
import { IPriceFormat } from '../Interfaces';

export class PriceFormatSource extends ArrayDataSource<IPriceFormat> {
  public constructor() {
    super('/datasource/priceformats');
  }
}